/**
 * Game loop a passo fisso per la logica (stabile su qualsiasi refresh rate,
 * incluso il 120Hz dei dispositivi mobili) e render a frequenza schermo.
 */

export interface LoopCallbacks {
  /** Aggiornamento logico, chiamato a passo fisso (in secondi). */
  update(dt: number): void;
  /** Render, chiamato una volta per frame con il fattore di interpolazione. */
  render(alpha: number): void;
}

const STEP = 1 / 60;
const MAX_ACCUM = 0.25; // evita la "spirale della morte" dopo un tab in background

export class GameLoop {
  private rafId = 0;
  private last = 0;
  private accumulator = 0;
  private running = false;

  constructor(private callbacks: LoopCallbacks) {}

  start(): void {
    if (this.running) return;
    this.running = true;
    this.last = performance.now();
    const frame = (now: number) => {
      if (!this.running) return;
      this.accumulator = Math.min(this.accumulator + (now - this.last) / 1000, MAX_ACCUM);
      this.last = now;
      while (this.accumulator >= STEP) {
        this.callbacks.update(STEP);
        this.accumulator -= STEP;
      }
      this.callbacks.render(this.accumulator / STEP);
      this.rafId = requestAnimationFrame(frame);
    };
    this.rafId = requestAnimationFrame(frame);
  }

  stop(): void {
    this.running = false;
    cancelAnimationFrame(this.rafId);
  }
}
